import { CreatorLifecycleState } from '../loop/creator-lifecycle';

/** Declarative rule: when a condition is met, lifecycle may advance. No evaluation logic. */
export interface LifecycleTriggerRule {
  readonly id: string;
  readonly fromState: CreatorLifecycleState;
  readonly toState: CreatorLifecycleState;
  readonly trigger: string;
  readonly conditionDescription: string;
}

export const LIFECYCLE_TRIGGER_RULES: readonly LifecycleTriggerRule[] = [
  {
    id: 'visitor_to_user',
    fromState: CreatorLifecycleState.VISITOR,
    toState: CreatorLifecycleState.USER,
    trigger: 'account_created',
    conditionDescription: 'User completes registration',
  },
  {
    id: 'user_to_aspiring_creator',
    fromState: CreatorLifecycleState.USER,
    toState: CreatorLifecycleState.ASPIRING_CREATOR,
    trigger: 'creator_onboarding_started',
    conditionDescription: 'User initiates creator profile setup',
  },
  {
    id: 'aspiring_to_active_creator',
    fromState: CreatorLifecycleState.ASPIRING_CREATOR,
    toState: CreatorLifecycleState.ACTIVE_CREATOR,
    trigger: 'engagement_threshold',
    conditionDescription:
      'Engagement score crosses minimum threshold after content is published',
  },
  {
    id: 'active_to_monetizing_creator',
    fromState: CreatorLifecycleState.ACTIVE_CREATOR,
    toState: CreatorLifecycleState.MONETIZING_CREATOR,
    trigger: 'purchase_activity',
    conditionDescription: 'At least one completed purchase attributed to creator',
  },
  {
    id: 'monetizing_to_scaled_creator',
    fromState: CreatorLifecycleState.MONETIZING_CREATOR,
    toState: CreatorLifecycleState.SCALED_CREATOR,
    trigger: 'sustained_growth',
    conditionDescription:
      'Sustained growth across visibility, engagement, and monetization scores',
  },
];

/** Lookup trigger rules applicable from a given lifecycle state. */
export function getLifecycleTriggerRulesFrom(
  state: CreatorLifecycleState,
): readonly LifecycleTriggerRule[] {
  return LIFECYCLE_TRIGGER_RULES.filter((rule) => rule.fromState === state);
}
